const shouldRequestBeBypassed = (url: string, bypassList: string[]) =>
  bypassList.some((item) => url.includes(item));

export default shouldRequestBeBypassed;
